<template>
    <div>
      <h3 data-aos="fade-left" >{{ $t('ac_cleaning.why_clean_ac_section.title') }}</h3>
      <p data-aos="fade-right" class="sub-text py-2" >{{ $t('ac_cleaning.why_clean_ac_section.subtitle') }}</p>
      <div v-for="(detail, index) in details" :key="index" class="details">
        <img src="/static/img/acCleaning/svg/Check.svg">
        <!-- <p class="list" v-html="detail.detail"></p> -->
        <p class="list" v-html="$t(`ac_cleaning.why_clean_ac_section.benefits.${index}`)"></p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data () {
      return {
        title: 'ทำไมต้องล้างแอร์เป็นประจำ',
        subtitle: 'ล้างแอร์เป็นประจำดีอย่างไร เพื่อสุขภาพที่ดีต้องล้างแอร์ตามระยะ',
        details: [
          {
            detail: 'ลดเชื้อโรคและเชื้อราในระบบแอร์'
          },
          {
            detail: 'ช่วยให้แอร์เย็นเร็ว ประหยัดไฟ'
          },
          {
            detail: 'ยืดอายุการใช้งานของเครื่อง'
          },
          {
            detail: 'ลดกลิ่นอับและปัญหาแอร์มีน้ำหยด'
          },
          {
            detail: 'การล้างแอร์เป็นการ “ดูแลสุขภาพ” ของทั้งเครื่อง <br/> และคนในบ้าน'
          }
        ]
      }
    }
  }
  </script>
  
  <style scoped lang="scss">
  @import '../../../static/sass/page/ac_cleaning.scss';
  

  .details {
    display: flex;
    gap: 8px;
    place-items: center;
    margin-bottom: 16px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }
  
  </style>
  


// WEBPACK FOOTER //
// src/components/acCleaningRe/WhyAirCleaning.vue